const API_URL = 'https://open.er-api.com/v6/latest/USD'

export async function fetchUsdToJpyRate(): Promise<number> {
  const res = await fetch(API_URL)
  if (!res.ok) {
    throw new Error(`Exchange rate API error: ${res.status}`)
  }
  const data = await res.json()
  const rate = data?.rates?.JPY
  if (typeof rate !== 'number' || rate <= 0) {
    throw new Error('Invalid JPY rate from API')
  }
  return rate
}

export function convertUsdToJpy(usd: number, rate: number): number {
  return Math.round(usd * rate)
}
